"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledInputWrapper = exports.StyledDiv = void 0;

var _reactEmotion = _interopRequireWildcard(require("react-emotion"));

var _emotionTheming = require("emotion-theming");

var wrapperStyles = function wrapperStyles() {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("display:flex;align-items:center;")
  );
};

var StyledDiv = (0, _emotionTheming.withTheme)(
/*#__PURE__*/
(0, _reactEmotion.default)("div", {
  target: "css-10e3qef0"
})(wrapperStyles));
exports.StyledDiv = StyledDiv;

var inputWrapperStyles = function inputWrapperStyles(_ref) {
  var isMinute = _ref.isMinute;
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("width:40px;text-align:right;", isMinute && "\n    width: 50px;\n  ")
  );
};

var StyledInputWrapper = (0, _emotionTheming.withTheme)(
/*#__PURE__*/
(0, _reactEmotion.default)("div", {
  target: "css-10e3qef1"
})(inputWrapperStyles));
exports.StyledInputWrapper = StyledInputWrapper;